import SvgIconStyle from 'components/SvgIconStyle';

export const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;
